var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtportLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 249.999 76.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_396",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 396",
    transform: "translate(-557.75 -120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_8",
    "data-name": "\\u30D1\\u30B9 8",
    d: "M76.241,16.125H89.59c5.67,0,10.549,0,15.573,4.234,3.444,3.158,5.023,7.249,5.023,12.2s-1.579,9.043-5.023,12.2C100.139,49,95.259,49,89.59,49H86.073V69.233H76.241Zm9.832,23.684h3.158c4.234,0,11.123-.287,11.123-7.249s-6.746-7.248-10.764-7.248H86.073Z",
    transform: "translate(535.997 115.399)",
    fill: "#0062b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9",
    "data-name": "\\u30D1\\u30B9 9",
    d: "M250.943,16.125h16.292c6.1,0,9.9,1.148,12.917,3.588A16.426,16.426,0,0,1,286.4,32.559c0,3.517-1.292,9.044-5.1,12.7a17.185,17.185,0,0,1-8.827,4.377L286.9,69.233H274.986l-14.068-20.31h-.142v20.31h-9.833Zm9.833,25.405h6.315c8.111,0,9.474-5.382,9.474-8.181,0-2.943-1.795-8.039-9.474-8.039h-6.315Z",
    transform: "translate(486.15 115.399)",
    fill: "#0062b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10",
    "data-name": "\\u30D1\\u30B9 10",
    d: "M318.268,25.311h-9.833V16.125H338v9.186h-9.9V69.233h-9.832Z",
    transform: "translate(469.746 115.399)",
    fill: "#0062b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11",
    "data-name": "\\u30D1\\u30B9 11",
    d: "M171.4,0a38.078,38.078,0,1,1-38.277,38.276A38.178,38.178,0,0,1,171.4,0m0,63.5c13.945,0,24.726-11.769,24.726-25.32,0-14.044-10.978-25.517-24.726-25.517s-24.726,11.473-24.726,25.517c0,13.55,10.78,25.32,24.726,25.32",
    transform: "translate(519.765 120)",
    fill: "#0062b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_12",
    "data-name": "\\u30D1\\u30B9 12",
    d: "M195.328,47.537a14.386,14.386,0,1,1-14.386-14.386,14.386,14.386,0,0,1,14.386,14.386",
    transform: "translate(510.228 110.541)",
    fill: "#0062b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13",
    "data-name": "\\u30D1\\u30B9 13",
    d: "M22.019,63.244h-5.97V61.086h-.071c-1.007,1.942-3.488,2.842-5.826,2.842C3.822,63.928.118,58.965.118,53.246.118,46.7,4.829,42.6,10.151,42.6c3.273,0,5.107,1.583,5.826,2.805h.071V43.285h5.97ZM11.05,58.353a5.091,5.091,0,1,0-4.963-5.035,4.93,4.93,0,0,0,4.963,5.035",
    transform: "translate(557.716 107.845)",
    fill: "#0062b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_14",
    "data-name": "\\u30D1\\u30B9 14",
    d: "M43.181,40.9h2.877v4.532H43.181V60.86h-5.97V45.433H34.263V40.9h2.949V34.249h5.97Z",
    transform: "translate(547.974 110.228)",
    fill: "#0062b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_39",
    "data-name": "\\u9577\\u65B9\\u5F62 39",
    width: 35.965,
    height: 7.193,
    transform: "translate(557.75 177.439)",
    fill: "#0062b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_40",
    "data-name": "\\u9577\\u65B9\\u5F62 40",
    width: 35.965,
    height: 7.193,
    transform: "translate(557.75 131.524)",
    fill: "#0062b1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtportLogo);
export default __webpack_public_path__ + "static/media/atport_logo.9a503b23568c593ab47983ce42f91c16.svg";
export { ForwardRef as ReactComponent };